import React, { useEffect, useState } from "react";
import Chat from "../Chat";
import "./ChatList.css";
import getFetchConfig from "../../../utils/getFetchConfig";
import appURLS from "../../../appURL";
import MarkUnreadChatAltIcon from '@mui/icons-material/MarkUnreadChatAlt';
import ImageIcon from '@mui/icons-material/Image';
import { io } from "socket.io-client";

function ChatList({ setrefreshList, refreshList, setmyselectedChat }) {
  const appURL = appURLS();
  const fetchConfig = getFetchConfig(); 

  const [newMessages, setnewMessages] = useState([]);
  const [expandedChatId, setExpandedChatId] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false); 

  const [detailData, setdetailData] = useState(true);
  const ENDPOINT = 'https://menehariya-chat.netscapelabs.com/';
  const sellerId = localStorage.getItem("sellerIdChat");

  const colorList = {
    A: "#00FFFF",
    B: "#0000FF",
    C: "#FF8C00",
    D: "#FFD700",
    E: "#008000",
    F: "#FF00FF",
    G: "#DDA0DD",
    H: "#FF69B4",
    I: "#4B0082",
    J: "#00A86B",
    K: "#F0E68C",
    L: "#E6E6FA",
    M: "#000080",
    N: "#E0115F",
    O: "#808000",
    P: "#800080",
    Q: "#E0D0C6",
    R: "#FF0000",
    S: "#C0C0C0",
    T: "#008080",
    U: "#808000",
    V: "#D2691E",
    W: "#EE82EE",
    X: "#738678",
    Y: "#FFFF00",
    Z: "#000000",
  };

  const [listData, setListData] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [socket, setSocket] = useState(null);
  const [messageTotalCount, setMessageTotalCount] = useState(0);

  const getMessageCount = localStorage.getItem("message_count");

  const chatlistsdetailsData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };
      const response = await fetch(`${appURL}/chat/chat-list`, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      setListData(jsonData?.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    const selectedChatId = selectedChat?._id;
    if (selectedChatId) {
      localStorage.setItem("selectedChatId", selectedChatId);
    }
  }, [selectedChat]);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;

  const checker = localStorage.getItem('adsIdChat');

  useEffect(() => {
    const socketUserId = userId || sellerId;
    const newSocket = io(ENDPOINT, {
      transports: ['websocket'],
      autoConnect: true,
      query: `userId=${socketUserId}`
    });

    newSocket.on('receive-message', (data) => {
      if (!data?._id || !data?.messages?.length) return;
      const incomingMessage = data.messages[0];
      const chatId = data._id;

      setListData(prev => {
        const index = prev.findIndex(chat => chat._id === chatId);
        if (index === -1) {
          chatlistsdetailsData();
          return prev;
        }

        const updatedChat = {
          ...prev[index],
          messages: [incomingMessage],
          messageCount: data.messageCount !== undefined ? data.messageCount : prev[index].messageCount,
        };

        const remaining = prev.filter(chat => chat._id !== chatId);
        return [updatedChat, ...remaining];
      });
    });

    setSocket(newSocket);

    return () => {
      newSocket.disconnect();
    };
  }, [userId]);

  const updateMessageCount = async (adsData, targetAdsId) => {
    const ad = adsData.find(item => item.ads_id === targetAdsId);
    if (ad) {
      ad.messageCount = 0;
    } else {
      console.log(`Ad with ads_id: ${targetAdsId} not found.`);
    }
    return adsData;
  };

  const handleListClick = (list, check) => {
    setmyselectedChat(list?._id);
    check !== 'hey' && setrefreshList(!refreshList);

    if (localStorage.getItem("forChatCount") === 'true') {
      localStorage.setItem("forChatCount", false);
    } else if (localStorage.getItem("forChatCount") === 'false') {
      localStorage.setItem("forChatCount", true);
    }

    localStorage.setItem("adsTypeChat", list?.ads_type);
    localStorage.setItem("adsIdChat", list?.ads_id);
    localStorage.setItem("sellerIdChat", list?.sellerId);
    localStorage.setItem("userIdchat", list?.buyerId);
    localStorage.setItem("buyerId", list?.buyerId);

    setSelectedChat(list);
    chatlistsdetailsData();

    // ✅ Close sidebar on mobile after selecting a chat
    setSidebarOpen(false);
  };

  const containsUrl = (message) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return urlRegex.test(message);
  };

  useEffect(() => {
    chatlistsdetailsData();
  }, [checker]);

  useEffect(() => {
    const handleStorageChange = () => {
      chatlistsdetailsData();
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  // ✅ Lock body scroll when sidebar is open on mobile
  useEffect(() => {
    if (sidebarOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [sidebarOpen]);

  const getBackgroundColor = (initial) => {
    const color = colorList[initial.toUpperCase()] || "#FFFFFF";
    return { backgroundColor: color };
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    let formattedTime = date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true });
    formattedTime = formattedTime.replace(/^0/, '');
    return formattedTime;
  };

  const truncateWords = (text, limit = 4) => {
    if (!text) return '';
    const words = text.split(' ');
    return words.length > limit ? words.slice(0, limit).join(' ') : text;
  };

  return (
    <div>
      <div className={`MainChat ${sidebarOpen ? "sidebar-open" : ""}`}>

        {/* ✅ Backdrop overlay — click to close sidebar */}
        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        />

        {/* ✅ Chat List Sidebar */}
        <div className="Chat_lists">
          <h2>
            Chats
            {/* ✅ Close (×) button — visible on mobile inside sidebar */}
            <button
              className="sidebar-close-btn"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close menu"
            >
              ×
            </button>
          </h2>

          {listData && Array.isArray(listData) && listData?.map((list, index) => (
            <div
              key={index}
              className="list_showing"
              onClick={() => handleListClick(list)}
              style={{ backgroundColor: `${selectedChat?._id === list?._id ? 'lightgray' : ''}` }}
            >
              <div className="image_profilo">
                {((list?.sellerId === (JSON.parse(localStorage.getItem("user"))?.userId) && (list?.buyer_image !== null && list?.buyer_image !== "null")) || (list?.sellerId !== (JSON.parse(localStorage.getItem("user"))?.userId) && (list?.seller_image !== null && list?.seller_image !== "null"))) ? (
                  <img
                    src={list?.sellerId === (JSON.parse(localStorage.getItem("user"))?.userId) ? list?.buyer_image : list?.seller_image}
                    alt="seller"
                  />
                ) : (
                  <div
                    className="seller_placeholder"
                    style={getBackgroundColor(list && list?.seller_name?.[0]?.toUpperCase() || list?.buyer_name[0].toUpperCase() || '')}
                  >
                    <p>
                      {list?.sellerId === JSON.parse(localStorage.getItem("user"))?.userId
                        ? (list?.buyer_name ? list.buyer_name[0] : '')
                        : (list?.seller_name ? list.seller_name[0] : '')}
                    </p>
                  </div>
                )}
              </div>

              <div className="chat_content">
                <div>
                  {list && list?.sellerId === JSON.parse(localStorage.getItem("user"))?.userId
                    ? <h5>{list?.buyer_name}</h5>
                    : <h5>{list?.seller_name}</h5>
                  }
                  {list && list?.ads_name && <p>{list?.ads_name}</p>}

                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    {list?.messages?.length > 0 && list?.messages[0]?.content && (() => {
                      const message = list.messages[0].content;
                      const isLong = message.split(' ').length > 4;
                      const isExpanded = expandedChatId === list._id;
                      const isUnseen =
                        list.messages[0].status === 'unseen' &&
                        list.messages[0].senderId !== JSON.parse(localStorage.getItem("user"))?.userId;

                      return (
                        <span
                          style={{
                            fontWeight: isUnseen ? 'bold' : 'normal',
                            color: isUnseen ? 'black' : 'gray',
                          }}
                        >
                          {containsUrl(message) ? (
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                              <ImageIcon />
                              <p>Image</p>
                            </div>
                          ) : (
                            <>
                              {isExpanded ? message : truncateWords(message, 4)}
                              {isLong && (
                                <span
                                  style={{
                                    marginLeft: 6,
                                    color: '#007bff',
                                    cursor: 'pointer',
                                    fontWeight: 'normal',
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setExpandedChatId(isExpanded ? null : list._id);
                                  }}
                                >
                                  {isExpanded ? '' : '...'}
                                </span>
                              )}
                            </>
                          )}
                        </span>
                      );
                    })()}
                  </div>
                </div>

                <div className="timer_stamp">
                  {list && list?.messages && list?.messages.length > 0 && (
                    <span>{formatTime(list?.messages[0].timestamp)}</span>
                  )}
                </div>

                {list?.messageCount !== 0 && (list?._id !== selectedChat?._id) && (
                  <span style={{ fontWeight: 'bold', display: 'flex', alignItems: 'flex-end', color: 'red' }}>
                    <MarkUnreadChatAltIcon />
                    {list?.messageCount ? list?.messageCount : ''}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* ✅ Chat Panel */}
        <div className="chat_model">

          {/* ✅ Chat list toggle button — only visible on mobile via CSS */}
          <button
            className="hamburger-btn"
            onClick={() => setSidebarOpen(prev => !prev)}
            aria-label="Toggle chat list"
          >
            {sidebarOpen ? (
              /* Close X icon when open */
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            ) : (
              /* Chat bubbles icon when closed */
              <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z"/>
                <path d="M7 9H17V11H7V9Z" opacity="0.6"/>
                <path d="M7 6H17V8H7V6Z"/>
                <path d="M7 12H13V14H7V12Z" opacity="0.4"/>
              </svg>
            )}
          </button>

          <Chat
            selectedChat={selectedChat}
            setSelectedChat={setSelectedChat}
            newMessages={newMessages}
            setnewMessages={setnewMessages}
            listData={listData}
            setdetailData={setdetailData}
          />
        </div>

      </div>
    </div>
  );
}

export default ChatList;